$(function () {

	gsap.to($('.tabs-content__itm.active'), {opacity: 1, duration: .2});

	var tab_gsap = false,
		tab_timeout;

	$('.tabs-nav__itm').on('click', function (e) {
		var parent = $(this).closest('.tabs'),
			id = $(this).find('a').attr('href'),
			index = $(this).index(),
			tl = gsap.timeline(),
			contents = $(id).closest('.tabs-content__itm').siblings('.tabs-content__itm');

		$(this).siblings('.tabs-nav__itm').removeClass('active');
		$(this).addClass('active');

		contents.removeClass('active');

		$(id).addClass('active');

		tl.to(contents, {opacity: 0, duration: .2});
		tl.to(contents.find('.text-with-ico'), {x: -30, duration: .2}, "<");

		tl.to($(id), {opacity: 1, duration: .2}, .2);
		tl.fromTo($(id).find('.text-with-ico'), {x: 30, opacity: 0}, {x: 0, duration: .3, opacity: 1},
			"<+=.1");

		let indicator = parent.find('.tabs-nav-indicator');

		gsap.to(indicator, {x: $(this).position().left});

		history.replaceState({}, '', '?tabs=' + id);

		if (parent.hasClass('sequence-change')) {
			let imgs = $('.front-sequence__img').eq(index).find('img')
			imgs.removeClass("active");
			imgs.first().addClass("active");

			if (tab_gsap !== false) {
				tab_gsap.pause();
			}

			gsap.fromTo($('.front-sequence__img.active'), {x: 0, opacity: 1}, {x: 0, opacity: 0, duration: .8});
			tab_gsap = gsap.fromTo($('.front-sequence__img').eq(index), {x: 0, opacity: 0}, {
				x: 0,
				opacity: 1,
				duration: 1,
				delay: 0.1,
			});

			if(!is_tablet_big) {
				clearTimeout(tab_timeout);
				tab_timeout = setTimeout(function () {
					sequence_play($('.window-sequence.active'));
				}, 100);
			}

			$('.front-sequence__img').removeClass('active');
			$('.front-sequence__img').eq(index).addClass('active');
		}

		return false;
	});

	$('.tabs').each(function () {
		let indicator = $(this).find('.tabs-nav-indicator'),
			active = $(this).find('.tabs-nav__itm.active');

		indicator.css({
			transform: 'translateX(' + active.position().left + 'px)'
		})
	});

	$(window).on('resize', function () {
		$(".tabs-nav__itm.active").each(function () {
			let parent = $(this).closest('.tabs'),
				indicator = parent.find('.tabs-nav-indicator');

			gsap.to(indicator, {x: $(this).position().left});
		});
	})


});